import { useContext, useEffect, useState } from 'react';
import { FieldProps } from '../type/form';
import { FormContext, FormItem } from '../../form';

import './style.scss';

export function FormTextarea(props: FieldProps) {
  const {
    name,
    label,
    placeHolder,
    tip,
    prefix,
    prompt,
    className = '',
    required,
    rules,
    group,
    defaultValue = '',
  } = props;

  const { dispatch } = useContext(FormContext);
  const [value, setValue] = useState('');
  // 输入框内的value改变
  function handleChange(event: any) {
    const inputValue = event.target.value;
    setValue(inputValue);
  }
  // 使高度自适应
  function changeHeight(event: any) {
    handleChange(event);
    event.target.style.height = 'inherit';
    event.target.style.height = `${event.target.scrollHeight}px`;
  }
  // 默认值
  useEffect(() => {
    setValue(defaultValue as string);
    dispatch({ name, type: 'change', payload: defaultValue });
  }, [defaultValue, dispatch, name]);

  return (
    <FormItem
      {...{
        name,
        label,
        tip,
        prefix,
        prompt,
        className,
        required,
        group,
        rules,
      }}
    >
      <textarea placeholder={placeHolder} className="form-textarea" onChange={changeHeight} rows={1} value={value} />
    </FormItem>
  );
}
